var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.89 0.119995H6.60999C3.09746 0.119995 0.24999 2.96746 0.24999 6.48V24.12H70.25V6.48C70.25 2.96746 67.4025 0.119995 63.89 0.119995Z",
    fill: "#0038A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.24999 40.75C0.24999 44.2625 3.09746 47.11 6.60999 47.11H63.88C65.5668 47.11 67.1845 46.4399 68.3772 45.2472C69.5699 44.0545 70.24 42.4368 70.24 40.75V24.12H0.23999L0.24999 40.75Z",
    fill: "#CE1126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14999 1.94998C0.931154 3.14573 0.246144 4.78254 0.249989 6.48998V40.76C0.251138 42.4852 0.955284 44.1354 2.19999 45.33L25.25 24.12L2.14999 1.94998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 27.62C12.4591 27.62 14.25 25.8291 14.25 23.62C14.25 21.4109 12.4591 19.62 10.25 19.62C8.04085 19.62 6.24999 21.4109 6.24999 23.62C6.24999 25.8291 8.04085 27.62 10.25 27.62Z",
    fill: "#F6D660"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhl);
export default __webpack_public_path__ + "static/media/PHL.4d221d39fe5ea9cefc88439de5385413.svg";
export { ForwardRef as ReactComponent };